import update from 'immutability-helper';
import { updateCurrentEntity } from 'actions/livefeed/historyActions'
import { isEqual } from 'lodash'
import moment from 'moment';


export function getPosition(pos) {
    return update(pos, {
        x: { $set: pos.x + 6 },//plus padding+border
        y: { $set: pos.y + 6 }
    });
}
export function handleSetCurrentEntity(currentEntity, newEntity, dispatch) {
    return isEqual(currentEntity, newEntity) === false && dispatch(updateCurrentEntity(newEntity))
}

export function generateSlideName(livefeedSlides, slide) {
    let hasSummarySlide = false;
    let hasLocationsListSlide = false;
    let slideShowCount = 0;
    let slideShow = [];
    for (let i = 0, n = livefeedSlides.length; i < n; i++) {
        switch (livefeedSlides[i].slideType) {
            case "summary":
                hasSummarySlide = true
                break;
            case "locationsList":
                hasLocationsListSlide = true
                break;
            default:
                slideShowCount += 1
                slideShow.push({ index: i, num: slideShowCount })
        }

    }
    let slideShowMap = new Map();
    slideShow.forEach((element) => slideShowMap.set(element.index, element))
    let slideName = slideShowMap.get(slide.id) ? `Slideshow ${slideShowMap.get(slide.id).num}` : '';


    if (hasSummarySlide && hasLocationsListSlide) {
        switch (slide.slideType) {
            case "summary":
                slideName = "Summary"
                break;
            case "locationsList":
                slideName = "Locations List"
                break;
        }
    } else if (hasSummarySlide && !hasLocationsListSlide) {
        switch (slide.slideType) {
            case "summary":
                slideName = "Summary"
                break;
        }
    }
  
    return slideName
}


function countTreeStatistic(root, map, isStandbyAsUnOccupied) {
    var statistic = {
        meetingRooms: 0,
        meetingRoomsInuse: 0,
        mrDesksInUse: 0,
        mrGoodSensors: 0,

        openAreaRooms: 0,
        openAreaRoomsInUse: 0,
        oaDesksInUse: 0,
        oaGoodSensors: 0,


        allGoodSensors: 0,
        allSensors: 0,// all include falty sensors, and not registered
        allDesksInUse: 0// only good sensors,
    };
    count(root, statistic, map, isStandbyAsUnOccupied);
    return statistic;
}
export function treatStandbySensor(isStandbyAsUnOccupied, standbyStatus) {
    // treat standby as occupied

    if (!isStandbyAsUnOccupied) {
        if (standbyStatus === true) {
            return true
        }
    } else {
        // treat standby as unoccupied
        if (standbyStatus === true) {
            return false
        }
    }
}

/*
IMPORTANT things,
the node object received in ttps://backend.senzodata.com/livefeedapi
for node that doesn't have children node, its default value is null
While on https://backend.senzodata.com/api, the default value is an empty array
so the condition for looping the count() is different
*/
function count(root, statistic, map, isStandbyAsUnOccupied) {
    if (root != null && root.children != null) {
        // get allGoodSensors and allSensors
        if (root.type == 'open_area' || root.type == "meeting_room") {
            root.children.forEach((sensor) => {
                let status = map.get(sensor.id);
                if (status.registered && status.lastonl + 24 * 60 * 60 > moment().unix() && !status.faulty) {
                    statistic.allGoodSensors++
                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
                        statistic.allDesksInUse++
                    }
                }
                statistic.allSensors++
            });
        }
        // count either open_area or meeting_room
        if (root.type == 'open_area') {
            statistic.openAreaRooms++;
            let occupied = false;
            root.children.forEach((sensor) => {
                let status = map.get(sensor.id);
                if (status) {
                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
                        occupied = true;
                        statistic.oaDesksInUse++;
                    }
                }
                if (status.registered && (status.lastonl + 24 * 60 * 60 > moment().unix()) && !status.faulty) {
                    statistic.oaGoodSensors++
                }
            });
            if (occupied) {
                statistic.openAreaRoomsInUse++;
            }
        } else if (root.type == "meeting_room") {
            statistic.meetingRooms++;
            let occupied = false;
            root.children.forEach((sensor) => {
                let status = map.get(sensor.id);
                if (status) {
                    if (status.inuse || treatStandbySensor(isStandbyAsUnOccupied, status.standby)) {
                        occupied = true;
                        statistic.mrDesksInUse++;
                    }
                }
                if (status.registered && (status.lastonl + 24 * 60 * 60 > moment().unix()) && !status.faulty) {
                    statistic.mrGoodSensors++
                }
            });
            if (occupied) {
                statistic.meetingRoomsInuse++;
            }
        }
    }
    // else recursive loop through children
    else if (root.children != null && root.children.length > 0) {
        root.children.forEach(function (node) {
            count(node, statistic, map, isStandbyAsUnOccupied);
        });
    }
}
export function getStats(node, allSensors, isStandbyAsUnOccupied) {
    let stats = countTreeStatistic(node, allSensors, isStandbyAsUnOccupied);
    return stats
}

export function constructOptions(tree, options) {
    if (tree.type !== 'customer' && tree.info.hasfloorplan) {
        options.push({ label: tree.info.name, values: tree, useownfp: tree.info.useownfp, id: tree.id });
    }
    if (tree.children && tree.type !== 'meeting_room' && tree.type !== 'open_area') {
        tree.children.forEach(function (element) {
            if (element.type !== "sensor") {
                constructOptions(element, options);
            }
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/livefeed/Editor/EditorContainer/common/commonFn.js